import { useLocalStorage } from "../../lib/localStorage";

export function useStoredApiToken(): [
  string | undefined,
  (token: string | undefined) => void,
] {
  return useLocalStorage("token");
}
